import React, { useContext, useEffect, useState } from "react";
import styles from "./ConnectPopUp.module.css";
import { Button, Dialog, TextareaAutosize } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { getApi, PatchApi } from "../../Utility/network";
import { AppContext } from "../../ContextApi/AppContext/AppContext";
import { useLocation, useParams } from "react-router-dom";
import {
  consumptionEngText,
  consumptionGermText,
  dashboardEngText,
  dashboardGermText,
} from "../Pannel/Pannel";

function ConnectPopUp({ handleClose, open }) {
  // showSnackbar
  const { state, setState, showSnackbar } = useContext(AppContext);
  const { stepLanguage, language } = state;

  const location = useLocation();
  let { id } = useParams();

  const [data, setData] = useState({
    title: "",
  });
  const Currentneed = location?.pathname?.includes("energy-certificate");

  useEffect(() => {
    // if (Currentneed) {
    if (state?.otherData?.question?.title) {
      setData({ title: state.otherData.question.title });
    }
    // }
  }, [state]);

  const hanndleSave = async () => {
    const url = Currentneed
      ? `energy_need/${id}/`
      : `energy_consumption/form/${id}/`;
    const answerData = { title: data?.title };

    try {
      const response = await PatchApi(url, {
        question: answerData,
      });
      showSnackbar("Fragen erfolgreich speichern");
    } catch (error) {}
  };
  const questionMail = async () => {
    const url = Currentneed
      ? `energy_need/${id}/send_question_via_email`
      : `energy_consumption/form/${id}/send_question_via_email`;
    try {
      const response = await getApi(url);
      showSnackbar("Frage erfolgreich per E-Mail gesendet");
    } catch (error) {}
  };
  const appointmentMail = async () => {
    const url = Currentneed
      ? `/energy_need/${id}/appointment_email`
      : `/energy_consumption/form/${id}/appointment_email`;
    try {
      const response = await getApi(url);
      showSnackbar("Termin erfolgreich gesendet");
    } catch (error) {}
  };
  const handleChange = (e) => {
    setData({ title: e.target?.value });
  };
  // showSnackbar
  return (
    <Dialog onClose={handleClose} open={open} maxWidth={"md"}>
      <div className={styles.con}>
        <div
          style={{ textAlign: "end", cursor: "pointer" }}
          onClick={handleClose}
        >
          <CloseIcon color="success" onClick={handleClose} />
        </div>
        <div className={styles.allCon}>
          <div className={styles.fieldCon}>
            <p className={styles.tag}>Name</p>
            {Currentneed ? (
              state?.needData?.billing_address == null ? (
                <p className={styles.data}>
                  {state?.user?.user.first_name || "-"}{" "}
                  {state?.user?.user.last_name || "-"}
                </p>
              ) : (
                <p className={styles.data}>
                  {state?.needData?.billing_address.first_name || "-"}{" "}
                  {state?.needData?.billing_address.last_name || "-"}
                </p>
              )
            ) : state?.otherData?.lastStep == null ? (
              <p className={styles.data}>
                {state?.user?.user.first_name || "-"}{" "}
                {state?.user?.user.last_name || "-"}
              </p>
            ) : (
              <p className={styles.data}>
                {state?.otherData?.lastStep.first_name || "-"}{" "}
                {state?.otherData?.lastStep.last_name || "-"}
              </p>
            )}
          </div>
          <div className={styles.fieldCon}>
            <p className={styles.tag}>
              {" "}
              {language == "de"
                ? consumptionGermText?.email
                : consumptionEngText?.email}
            </p>
            {Currentneed ? (
              state?.needData?.billing_address == null ? (
                <p className={styles.data}>{state?.user?.user.email || "-"}</p>
              ) : (
                <p className={styles.data}>
                  {state?.needData?.billing_address.email || "-"}
                </p>
              )
            ) : state?.otherData?.lastStep == null ? (
              <p className={styles.data}>{state?.user?.user.email || "-"}</p>
            ) : (
              <p className={styles.data}>
                {state?.otherData?.lastStep.email || "-"}
              </p>
            )}
          </div>
          <div className={styles.fieldCon}>
            <p className={styles.tag}>
              {" "}
              {language == "de"
                ? consumptionGermText?.phone_no
                : consumptionEngText?.phone_no}
            </p>
            {Currentneed ? (
              state?.needData?.billing_address == null ? (
                <p className={styles.data}>{"-"}</p>
              ) : (
                <p className={styles.data}>
                  {state?.needData?.billing_address?.phone || "-"}
                </p>
              )
            ) : state?.otherData?.lastStep == null ? (
              <p className={styles.data}>{"-"}</p>
            ) : (
              <p className={styles.data}>
                {state?.otherData?.lastStep?.phone || "-"}
              </p>
            )}
          </div>
          <div className={styles.fieldCon}>
            <p className={styles.tag}>
              {" "}
              {language == "de"
                ? consumptionGermText?.Address
                : consumptionEngText?.Address}
            </p>
            {Currentneed ? (
              state?.needData?.billing_address == null ? (
                <p className={styles.data}>{"-"}</p>
              ) : (
                <p className={styles.data}>
                  {state?.needData?.billing_address?.street || "-"}
                </p>
              )
            ) : state?.otherData?.lastStep == null ? (
              <p className={styles.data}>{"-"}</p>
            ) : (
              <p className={styles.data}>
                {state?.otherData?.lastStep.street || "-"}
              </p>
            )}
          </div>
          <div style={{ width: "100%", marginTop: "10px" }}>
            <p className={styles.tag}>
              {language == "de"
                ? consumptionGermText?.clarification
                : consumptionEngText?.clarification}
            </p>

            <textarea
              style={{ height: "200px ", width: "100%" }}
              value={data?.title}
              onChange={(e) => handleChange(e)}
            ></textarea>
          </div>
        </div>
        <div className={styles.onebtn}>
          <Button
            variant="contained"
            sx={{
              padding: "12px 25px",
              background: " linear-gradient(90deg, #22A156 0%, #AFDB28 100%)",
              boxShadow: "none",
              borderRadius: "10px",
              color: "white",
              "&:disabled": {
                background: "gray",
                color: "#ccc",
              },
            }}
            onClick={() => hanndleSave()}
          >
            {language == "de"
              ? consumptionGermText?.save_questions
              : consumptionEngText?.save_questions}
          </Button>
        </div>
        <div className={styles.btnall}>
          <Button
            variant="outlined"
            sx={{
              padding: "12px 25px",
              // background: " linear-gradient(90deg, #22A156 0%, #AFDB28 100%)",
              boxShadow: "none",
              borderRadius: "10px",
              color: "white",
              "&:disabled": {
                background: "gray",
                color: "#ccc",
              },
            }}
            onClick={() => handleClose()}
          >
            {language == "de"
              ? consumptionGermText?.close
              : consumptionEngText?.close}
          </Button>

          <Button
            variant="contained"
            sx={{
              padding: "12px 25px",
              background: " linear-gradient(90deg, #22A156 0%, #AFDB28 100%)",
              boxShadow: "none",
              borderRadius: "10px",
              color: "white",
              "&:disabled": {
                background: "gray",
                color: "#ccc",
              },
            }}
            onClick={() => questionMail()}
          >
            {language == "de"
              ? consumptionGermText?.send_email
              : consumptionEngText?.send_email}
          </Button>

          <Button
            variant="contained"
            sx={{
              padding: "12px 25px",
              background: " linear-gradient(90deg, #22A156 0%, #AFDB28 100%)",
              boxShadow: "none",
              borderRadius: "10px",
              color: "white",
              "&:disabled": {
                background: "gray",
                color: "#ccc",
              },
            }}
            onClick={() => appointmentMail()}
          >
            {language == "de"
              ? consumptionGermText?.appointment
              : consumptionEngText?.appointment}
          </Button>
        </div>
      </div>
    </Dialog>
  );
}

export default ConnectPopUp;
